// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import type Enums from '../Enums';
import {
  NewProjectConfigSummaryPlant,
  type ProjectConfigSummaryPlant,
  type ProjectConfigSummaryPlantWireFormat,
} from '../ProjectConfigSummaryPlant/ProjectConfigSummaryPlant';

export class ProjectConfigSummary {
  readonly id: string;
  readonly name: string;
  readonly plants: ProjectConfigSummaryPlant[];
  readonly readyMixQuantityOverride: string | null;
  readonly readyMixQuantityOverrideUnit: Enums.Unit | null;
  readonly aggregateQuantityOverride: string | null;
  readonly aggregateQuantityOverrideUnit: Enums.Unit | null;
  readonly asphaltQuantityOverride: string | null;
  readonly asphaltQuantityOverrideUnit: Enums.Unit | null;
  readonly revenueOverride: string | null;
  readonly plantId: string;
  readonly marketId: string;
  readonly divisionId: string | null;
  readonly isArchived: boolean;
  readonly plantIsArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.plants = (data.plants ?? []).map((plants: any) => NewProjectConfigSummaryPlant(plants));
    this.readyMixQuantityOverride =
      data.readyMixQuantityOverride === undefined ? null : data.readyMixQuantityOverride;
    this.readyMixQuantityOverrideUnit =
      data.readyMixQuantityOverrideUnit === undefined ? null : data.readyMixQuantityOverrideUnit;
    this.aggregateQuantityOverride =
      data.aggregateQuantityOverride === undefined ? null : data.aggregateQuantityOverride;
    this.aggregateQuantityOverrideUnit =
      data.aggregateQuantityOverrideUnit === undefined ? null : data.aggregateQuantityOverrideUnit;
    this.asphaltQuantityOverride =
      data.asphaltQuantityOverride === undefined ? null : data.asphaltQuantityOverride;
    this.asphaltQuantityOverrideUnit =
      data.asphaltQuantityOverrideUnit === undefined ? null : data.asphaltQuantityOverrideUnit;
    this.revenueOverride = data.revenueOverride === undefined ? null : data.revenueOverride;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.plantIsArchived = data.plantIsArchived === undefined ? false : data.plantIsArchived;
  }

  static zero(): ProjectConfigSummary {
    const zeroValues: ExcludeMethodsDeep<ProjectConfigSummary> = {
      id: NIL_UUID,
      name: '',
      plants: [],
      readyMixQuantityOverride: null,
      readyMixQuantityOverrideUnit: null,
      aggregateQuantityOverride: null,
      aggregateQuantityOverrideUnit: null,
      asphaltQuantityOverride: null,
      asphaltQuantityOverrideUnit: null,
      revenueOverride: null,
      plantId: NIL_UUID,
      marketId: NIL_UUID,
      divisionId: null,
      isArchived: false,
      plantIsArchived: false,
    };
    return new ProjectConfigSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectConfigSummaryWireFormat = {
  id: string;
  name: string;
  plants: ProjectConfigSummaryPlantWireFormat[];
  readyMixQuantityOverride: string | null;
  readyMixQuantityOverrideUnit: string | null;
  aggregateQuantityOverride: string | null;
  aggregateQuantityOverrideUnit: string | null;
  asphaltQuantityOverride: string | null;
  asphaltQuantityOverrideUnit: string | null;
  revenueOverride: string | null;
  plantId: string;
  marketId: string;
  divisionId: string | null;
  isArchived: boolean;
  plantIsArchived: boolean;
};

type NewProjectConfigSummaryProps = PartialDeep<ProjectConfigSummary, { recurseIntoArrays: true }>;
export const NewProjectConfigSummary: (
  props: NewProjectConfigSummaryProps,
) => ProjectConfigSummary = (props) => new ProjectConfigSummary(props);

type NewProjectConfigSummaryFromWireFormatProps = PartialDeep<
  ProjectConfigSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectConfigSummaryFromWireFormat: (
  props: NewProjectConfigSummaryFromWireFormatProps,
) => ProjectConfigSummary = (props) => new ProjectConfigSummary(props);
